import {type FC, memo} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props as ModalProps} from '@src/components/ModalNew';

import Modal from '@src/components/ModalNew';

import type {Props as CRUProgramPaymentPlanProps} from './PaymentPlan';

import CRUProgramPaymentPlan from './PaymentPlan';

type Props = Partial<ModalProps> & CRUProgramPaymentPlanProps;

const CRUProgramPaymentPlanModal: FC<Props> = ({
  children,
  duration,
  onSet,
  paymentPlan,
  ...modalProps
}) => {
  const {t} = useI18n();

  return (
    <Modal {...modalProps} title={t('shared:CRUProgramPaymentPlan.title')}>
      <CRUProgramPaymentPlan
        duration={duration}
        onSet={onSet}
        paymentPlan={paymentPlan}
      />
      {children}
    </Modal>
  );
};

export default memo(CRUProgramPaymentPlanModal);
